var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.alert)?_c('app-alert',{attrs:{"type":_vm.alert.type,"value":true},scopedSlots:_vm._u([{key:"default",fn:function(){return [_c('p',[_vm._v(_vm._s(_vm.alert.message))])]},proxy:true}],null,false,1019452855)}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }